// @mui material components
import Grid from "@mui/material/Grid";
import { useEffect, useCallback } from "react";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Settings page components
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import Sidenav from "layouts/pages/account/settings/components/Sidenav";
import BasicInfo from "layouts/pages/account/settings/components/BasicInfo";
import ChangePassword from "layouts/pages/account/settings/components/ChangePassword";

function Settings() {
  const handleResizeError = useCallback(() => {
    let resizeTimeout;
    let rafId;

    const handleResize = () => {
      // Lösche vorherige Timeouts/RAF
      if (resizeTimeout) clearTimeout(resizeTimeout);
      if (rafId) cancelAnimationFrame(rafId);

      // Setze einen neuen Timeout mit Drosselung
      resizeTimeout = setTimeout(() => {
        rafId = requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }, 250); // Längere Verzögerung für bessere Performance
    };

    // Event Listener hinzufügen
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimeout) clearTimeout(resizeTimeout);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  useEffect(() => {
    const cleanup = handleResizeError();
    return () => cleanup();
  }, [handleResizeError]);

  return (
    <BaseLayout>
      <SoftBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Sidenav />
          </Grid>
          <Grid item xs={12} lg={9}>
            <SoftBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <BasicInfo />
                </Grid>
                <Grid item xs={12}>
                  <ChangePassword />
                </Grid>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </BaseLayout>
  );
}

export default Settings;
